module.exports = __webpack_public_path__ + "ff7ff9314501c16c8f320d1c64a2daa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/0-star.svg
// module id = 972
// module chunks = 0